
export const ingredientColumns = [
  //{ field: "id", headerName: "ID", width: 70 },
  { field: "name", headerName: "Name", width: 230 },
  { field: "manufacturerCode", headerName: "Code", width: 70 },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
  {field: "quantity", headerName: "Quantity", width: 230},
];

export const doughColumns = [
  //{ field: "id", headerName: "ID", width: 70 },
  { field: "name", headerName: "Name", width: 230 },
  { field: "manufacturerCode", headerName: "Code", width: 70 },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];

export const productColumns = [
  { field: "name", headerName: "Name", width: 230 },
  { field: "manufacturerCode", headerName: "Code", width: 70 },
  //{ field: "id", headerName: "ID", width: 70 },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];

export const lineColumns = [
  { field: "name", headerName: "Name", width: 230 },

];

export const ovenColumns = [
  { field: "name", headerName: "Name", width: 230 },
  { field: "capacity", headerName: "Capacity", width: 110 },
  { field: "bakeTimeMinutes", headerName: "Bake Time (min)", width: 140 },
  { field: "throughputPerHour", headerName: "Throughput/hr", width: 130 },

];

export const productionListColumns = [
  { field: "name", headerName: "Name", width: 230 },

];


export const userColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "user",
    headerName: "User",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img className="cellImg" src={params.row.img} alt="avatar" />
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
  },

  {
    field: "age",
    headerName: "Age",
    width: 100,
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];
